export class Album {
    constructor() {
    }

    albumId: string;
    name: string;
    picture: string;
    artistId: string;
    artistName: string;
}
